module.exports = __webpack_public_path__ + "img/flower-bg.24dd080e.jpg";